// Web polyfill for @react-navigation/elements/useFrameSize
// This fixes "require is not defined" error on web
import React, { useState, useEffect, createContext, useContext } from 'react';

// Context for frame size
const FrameSizeContext = createContext({
  width: typeof window !== 'undefined' ? window.innerWidth : 0,
  height: typeof window !== 'undefined' ? window.innerHeight : 0,
});

// Provider component
export function FrameSizeProvider({ children }) {
  const [dimensions, setDimensions] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return React.createElement(
    FrameSizeContext.Provider,
    { value: dimensions },
    children
  );
}

// Hook to use frame size
export function useFrameSize() {
  return useContext(FrameSizeContext);
}

// Default export for compatibility
export default {
  FrameSizeProvider,
  useFrameSize,
};

